import { render, staticRenderFns } from "./DataInputFloat.vue?vue&type=template&id=60b7c183&"
import script from "./DataInputFloat.vue?vue&type=script&lang=js&"
export * from "./DataInputFloat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports